import { render, staticRenderFns } from "./UploadMobile.vue?vue&type=template&id=5bd09be1&scoped=true&"
import script from "./UploadMobile.vue?vue&type=script&lang=js&"
export * from "./UploadMobile.vue?vue&type=script&lang=js&"
import style0 from "./UploadMobile.vue?vue&type=style&index=0&id=5bd09be1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd09be1",
  null
  
)

export default component.exports